import React, {useEffect, useState} from "react";
import {FlyerPageSpotDto, PromoDto, SelectPageForTabsDto} from "../../../../../dtos";
import styles from './LeftMenuContent.module.scss'
import {useTypedSelector} from "../../../../../hooks/useTypeSelector";
import {LeftMenuContentElement} from "./LeftMenuContentElement/LeftMenuContentElement";
import {getFlippingFlyer} from "../../../../../store";
import {useDispatch} from "react-redux";


interface Props {
    frames: FlyerPageSpotDto[];
    setFrames: (e: FlyerPageSpotDto[]) => void;
    setTargetPromos: (e: any) => void;
    isSelectAll: boolean;
    // toggleSelectAllChecker: (value: boolean) => void;
    onSelectFrame: (event: React.MouseEvent<HTMLElement>, promo: PromoDto, index: number, frame: FlyerPageSpotDto) => void;
    selectedPromos: PromoDto[];
    selectedFrames: FlyerPageSpotDto[];
    setExpandedPromos: (promos: PromoDto[]) => void;
    expandedPromos: PromoDto[];
}


export const LeftMenuContent = React.memo((props: Props) => {

    let flayerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const dispatch = useDispatch();
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    let [isHebrew, setHebrewLang] = useState<boolean>(false);

    useEffect(() => {
        // if (promotionsItemsState.type === 'CREATE_ITEM_SUCCESS' || promotionsItemsState.type === 'UPDATE_ITEM_SUCCESS') {
        if (promotionsItemsState.type === 'CREATE_PROMOTION_ITEM_SUCCESS' || promotionsItemsState.type === 'EDIT_PROMOTION_ITEM_SUCCESS') {
            dispatch(getFlippingFlyer(flayerDetailsState.flyRecId));
        }
    }, [promotionsItemsState.type]);

    useEffect(() => {
        setHebrewLang(flayerDetailsState?.flyLacRec?.lacCode! === 'he-IL')
    }, [flayerDetailsState]);

    const onChangeExpandedPromosData = (isAddPromo: boolean, targetPromo: PromoDto) => {
        if (isAddPromo) {
            props.setExpandedPromos([...props.expandedPromos, targetPromo])
        } else {
            const newExpandedPromosState = props.expandedPromos.filter((expandedPromo: PromoDto) => expandedPromo.flrRecId !== targetPromo.flrRecId);
            props.setExpandedPromos(newExpandedPromosState);
        }
    }

    //render promos using frames
    const framesRows = props.frames.map((key: FlyerPageSpotDto, index: number) => {
        const currentPageState = promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo];
        let promo: PromoDto = key.flyerPromos![key.flyerPromos!.length - 1 < 0 ? 0 : key.flyerPromos!.length - 1];
        if (currentPageState && currentPageState.promos && currentPageState.promos.length && promo) {
            const promoFromState = currentPageState.promos.find((promoFromState: PromoDto) => promoFromState.flrRecId === promo.flrRecId);
            if (promoFromState) {
                promo = promoFromState;
            }
        }
        const isSelect = props.selectedFrames.filter((selectedFrame: FlyerPageSpotDto) => {
            if (selectedFrame.fpsRecId === key.fpsRecId) {
                return key;
            }
        });
        return (
            <LeftMenuContentElement
                key={`${key.fpsCode?.toString()}${key.fpsRecId?.toString()}${index}`}
                frame={key}
                promo={promo}
                isHebrew={isHebrew}
                currencySymbol={flayerDetailsState.flyLacRec.lacCurrencySymbol!}
                index={index}
                setFrames={props.setFrames}
                frames={props.frames}
                setTargetPromos={props.setTargetPromos}
                onSelectFrame={props.onSelectFrame}
                isSelect={isSelect.length !== 0}
                onChangeExpandedPromosData={onChangeExpandedPromosData}
                expandedPromos={props.expandedPromos}
            />
        )

    });
    return (
        <div className={styles.frames_wrapper}>
            {framesRows}
        </div>
    )
})